import React from 'react';
import { Route, Switch, useRouteMatch } from 'react-router-dom';

import BusStopCreate from './BusStopCreate';
import BusStopEdit from './BusStopEdit';
import BusStopList from './BusStopList';

const BusStopPage = (props) => {
    let { path } = useRouteMatch();
    const refreshRef = React.useRef(null);
    const triggerRefresh = () => { if (refreshRef.current) refreshRef.current(); };

    return (
        <Switch>
            <Route path={`${path}/new`}>
                <BusStopList {...props} onRefreshRef={refreshRef} />
                <BusStopCreate {...props} onCreated={triggerRefresh} />
            </Route>
            <Route path={`${path}/:id`}>
                <BusStopList {...props} onRefreshRef={refreshRef} />
                <BusStopEdit {...props} onSaved={triggerRefresh} />
            </Route>
            <Route exact path={path}>
                <BusStopList {...props} />
            </Route>
        </Switch>
    );
};

export default BusStopPage;
